import appConfig from 'app.config'
import React, { useEffect, useRef } from 'react'

interface DixaChatbotProps {
	firstName: string
	lastName: string
	email: string
	market: string
}

const DixaChatbot: React.FC<DixaChatbotProps> = ({
	firstName,
	lastName,
	email,
	market,
}) => {
	const scriptRef = useRef<HTMLScriptElement | null>(null)

	useEffect(() => {
		if (market === "de" || market === "at") {
			if (scriptRef.current) return

			if (!window._dixa_) {
				window._dixa_ = {
					invoke: function (method: string, args: any) {
						window._dixa_!.pendingCalls =
							window._dixa_!.pendingCalls || []
						window._dixa_!.pendingCalls.push([method, args])
					},
					addListener: function (event: string, listener: Function) {
						window._dixa_!.pendingAddListenerCalls =
							window._dixa_!.pendingAddListenerCalls || []
						window._dixa_!.pendingAddListenerCalls.push([
							event,
							listener,
						])
					},
				}
			}

			const dixa = window._dixa_!

			const script = document.createElement('script')
			scriptRef.current = script

			script.type = 'text/javascript'
			script.setAttribute('charset', 'utf-8')
			script.async = true
			script.src = 'https://messenger.dixa.io/bootstrap.js'

			script.onload = () => {
				try {
					dixa.invoke('init', {
						messengerToken: appConfig.dixaMessengerToken,
						userIdentity: {
							type: 'claim',
							name: `${firstName} ${lastName}`,
							email: email,
						},
						position: 'bottomRight',
						showWidgetCloseButton: true,
						language: market.toLowerCase(),
					})
				} catch (error) {
					console.error('Error initializing Dixa:', error)
				}
			}

			script.onerror = (error) => {
				console.error('Error loading Dixa script:', error)
			}

			document.head.appendChild(script)

			return () => {
				if (script.parentNode) {
					script.parentNode.removeChild(script)
					scriptRef.current = null
				}
				if (window._dixa_) {
					try {
						window._dixa_.invoke('destroy')
					} catch (error) {
						console.error('Error destroying Dixa:', error)
					}
				}
			}
		}
	}, [firstName, lastName, email, market])

	return null
}

export default DixaChatbot
